import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon, MapPinIcon } from 'lucide-react';
import { statusLabels, statusOrder, type RequestStatus } from '../../data/demandes';
import { useRequests } from '../../contexts/RequestsContext';
export function StatusProgress({
  status
}: {
  status: RequestStatus;
}) {
  const currentIndex = statusOrder.indexOf(status);
  return <ol className="flex items-center gap-2" aria-label={`Statut : ${statusLabels[status]}`} data-id="element-1063" data-mp="jtejb5w7nzyy">
      {statusOrder.map((step, index) => {
      const reached = index <= currentIndex;
      return <li key={step} className="flex items-center gap-2" data-id="element-1064" data-mp="su2n77rw4jy4" data-mpi={index}>
            <span className={`rounded-full px-3 py-1 text-xs font-bold ${index === currentIndex ? 'bg-ville-indigo text-white' : reached ? 'bg-ville-indigo-soft text-ville-indigo' : 'bg-slate-100 text-slate-400'}`} data-id="element-1065" data-mp="sum7uw8xdmfu">
              {statusLabels[step]}
            </span>
            {index < statusOrder.length - 1 && <span className={`h-0.5 w-5 rounded-full ${index < currentIndex ? 'bg-ville-indigo' : 'bg-slate-200'}`} aria-hidden="true" data-id="element-1066" data-mp="idddfbpfzx6r" />}
          </li>;
    })}
    </ol>;
}
export function RequestList() {
  const {
    requests
  } = useRequests();
  return <section aria-labelledby="mes-demandes-titre" data-id="element-1067" data-mp="162o7ybg78vcg">
      <h2 id="mes-demandes-titre" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-1068" data-mp="114d0269gsuwv">
        Mes demandes
      </h2>
      <p className="mt-1 text-[15px] text-slate-600" data-id="element-1069" data-mp="x1gjel3hj8vk">Suivez l’avancement de ce que vous avez signalé.</p>

      <ul className="mt-6 space-y-3" data-id="element-1070" data-mp="s2n8n0fl1vz3">
        {requests.map(request => <li key={request.id} data-id="element-1071" data-mp="3ht0lwk6uh0w1">
            <Link to={`/mes-demandes/${request.id}`} className="group flex flex-wrap items-center gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-4 transition-colors duration-150 ease-ville hover:border-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1072" data-mp="3hubmyc8wnujg">
              <div className="min-w-0 flex-1" data-id="element-1073" data-mp="35aeqg8fajz5g">
                <div className="flex flex-wrap items-center gap-2" data-id="element-1074" data-mp="359lg6xh4irik">
                  <h3 className="text-[15px] font-extrabold text-ville-navy" data-id="element-1075" data-mp="39ayorfblp8t6">{request.title}</h3>
                  <span className="text-xs font-semibold text-slate-400" data-id="element-1076" data-mp="2vk1xbrteuxnp">{request.reference}</span>
                </div>
                <p className="mt-1 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-slate-500" data-id="element-1077" data-mp="30btqma3ybhhj">
                  <span className="flex items-center gap-1.5" data-id="element-1078" data-mp="2lngoswi6n4f4">
                    <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-1079" data-mp="2qkpav86gbsln" />
                    {request.address}
                  </span>
                  <span data-id="element-1080" data-mp="2cmsfug7nbu93">{request.submittedOn}</span>
                </p>
                <div className="mt-3" data-id="element-1081" data-mp="2hktv0q1yb9fa">
                  <StatusProgress status={request.status} data-id="element-1082" data-mp="2hjr5omka1f1h" />
                </div>
              </div>
              <ChevronRightIcon className="h-5 w-5 shrink-0 text-slate-400 transition-colors duration-150 ease-ville group-hover:text-ville-indigo" aria-hidden="true" data-id="element-1083" data-mp="1xz0q88nwbinu" />
            </Link>
          </li>)}
      </ul>
    </section>;
}